import { render, staticRenderFns } from "./comStep0.vue?vue&type=template&id=318b2589&scoped=true&"
import script from "./comStep0.vue?vue&type=script&lang=js&"
export * from "./comStep0.vue?vue&type=script&lang=js&"
import style0 from "./comStep0.vue?vue&type=style&index=0&id=318b2589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318b2589",
  null
  
)

export default component.exports